export class DtoConstant{
    
   static readonly DTO_STRUCTURED_TYPE_REF:string="DtoStructureTypeRef";

   static readonly EXTEND_STRUCTURE_TYPE:string="ExtendStructureType";

   static readonly EXTEND_ENUM_TYPE:string="ExtendEnumType";
}